import { gsap } from "gsap";

export default class Quickshop extends HTMLElement {

	constructor(){

		super();

		this.targetId = this.dataset.target;
		this.button = this.querySelector("button");
		this.overlay  = document.getElementById(this.targetId);
		this.open = false;

		if(!this.overlay) return;

		this.close = this.overlay.querySelectorAll("[data-close]");

		this.button.addEventListener("click", this.toggleOpen.bind(this));
		this.overlay.addEventListener("click", this.toggleOpen.bind(this));

		this.fadeEl = this.overlay.querySelector(".fade-el");
		this.slideEl = this.overlay.querySelector(".slide-el");
	}

	toggleOpen(event) {

		let target = event.target;

		/** bounce clicks */
		if(target != this && target.parentElement != this && target.dataset.close == undefined) return;

		event.stopPropagation();

		/** open */
		if(this.open === false){

			gsap.to(this.fadeEl, { duration: 0.3, autoAlpha: 1 });
			gsap.to(this.slideEl, { duration: 0.3, x: 0 });

			this.open = true;

			return;
		}

		/** close */
		gsap.to(this.fadeEl, { duration: 0.3, autoAlpha: 0 });
		gsap.to(this.slideEl, { duration: 0.3, x: "100%" });

		this.open = false;
	}
}